import type { PublicEnergyLabel, PublicLanguage } from '@/entities/publicReport';

import type { PublicCopy } from '../copy';
import { formatCount } from '../format';
import { ActionLink } from './ActionLink';
import { PublicBlock } from './PublicBlock';

export interface EnergyLabelBlockProps {
    label: PublicEnergyLabel;
    language: PublicLanguage;
    copy: PublicCopy;
}

/**
 * De labelbadge draagt de accentkleur van het bedrijf, want dat is de enige
 * accentkleur op deze pagina.
 */
export function EnergyLabelBlock({ label, language, copy }: EnergyLabelBlockProps) {
    const headline =
        label.usage === null
            ? `${copy.energyLabelPrefix} ${label.code}`
            : `${copy.energyLabelPrefix} ${label.code} · ${formatCount(label.usage, language)} ${copy.energyUsageUnit}`;

    return (
        <PublicBlock className="flex flex-wrap items-center gap-4">
            <span className="rounded-[9px] bg-[var(--accent)] px-[26px] py-3 font-[family-name:var(--font-display)] text-[30px] leading-none font-bold text-[var(--text-on-dark)]">
                {label.code}
            </span>

            <div className="min-w-0 flex-[1_1_240px]">
                <div className="text-[15px] leading-[1.35] font-medium text-[var(--text-primary)]">
                    {headline}
                </div>
                {label.advice ? (
                    <p className="mt-1 mb-0 text-[13px] leading-[1.5] text-[var(--text-tertiary-safe)]">
                        {label.advice}
                    </p>
                ) : null}
            </div>

            {label.pdfUrl ? (
                <ActionLink href={label.pdfUrl} variant="outline" size="md">
                    {`${copy.energyLabelPrefix} (PDF)`}
                </ActionLink>
            ) : null}
        </PublicBlock>
    );
}
